// import axios from 'axios';
// import {
//   Box,
//   Flex,
//   Text,
// } from "@chakra-ui/react";
// import Card from "components/card/Card.js";
// import React, { useState, useEffect } from "react";
// import ReactApexChart from "react-apexcharts";

// export default function Mensal({ data, anos }) {
//   const [barChart, setbarChart] = useState([]);
//   const [ano, setAno] = useState('');

//   useEffect(() => {
//     setbarChart(data);
//     setAno(anos);
//   }, [data]);

//   const mesesAno = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
//   const series = {};
//   let valorTotalGeral = 0;

//   for (let i = 0; i < barChart.length; i++) {
//     const dado = barChart[i];
//     const name = dado.Status;

//     if (!series[name]) {
//       series[name] = {
//         name: name,
//         data: [],
//       };
//     }

//     valorTotalGeral += dado.Total;

//     series[name].data.push({
//       x: dado.Mes,
//       y: dado.Total
//     });

//     series[name].data.sort((a, b) => a.x - b.x);
//   }

//   for (const serie of Object.values(series)) {
//     const dataMonths = serie.data.map(ponto => ponto.x);
//     for (const month of mesesAno) {
//       if (!dataMonths.includes(month)) {
//         serie.data.push({ x: month, y: 0 });
//       }
//     }
//   }

//   // Ordena os meses corretamente
//   const mesesNaOrdemDesejada = [...mesesAno];
//   const mapaMeses = {};
//   mesesNaOrdemDesejada.forEach((mes, index) => {
//     mapaMeses[mes] = index;
//   });

//   const reorganizarSeriesArray = (seriesArray, mesesMap) => {
//     return seriesArray.map(series => ({
//       ...series,
//       data: series.data.sort((a, b) => mesesMap[a.x] - mesesMap[b.x])
//     }));
//   };

//   let seriesArray = Object.values(series);
//   seriesArray = reorganizarSeriesArray(seriesArray, mapaMeses);

//   // 🔍 Filtra os meses com todos os valores zero
//   const mesesComValor = new Set();
//   for (const serie of seriesArray) {
//     for (const ponto of serie.data) {
//       if (ponto.y !== 0) {
//         mesesComValor.add(ponto.x);
//       }
//     }
//   }

//   // Remove meses que não estão no set
//   seriesArray = seriesArray.map(serie => ({
//     ...serie,
//     data: serie.data.filter(ponto => mesesComValor.has(ponto.x))
//   }));

//   const title = ano + " - Valor Total do Período - R$" + valorTotalGeral.toLocaleString('pt-BR', { minimumFractionDigits: 2 });

//   const options = {
//     chart: {
//       type: 'bar',
//       height: 500,
//       stacked: true,
//       toolbar: { show: false },
//       zoom: { enabled: false }
//     },
//     title: {
//       text: title,
//       align: 'center',
//       margin: 10,
//       style: {
//         fontSize: '18px',
//         fontWeight: 'bold',
//         color: 'white'
//       },
//     },
//     plotOptions: {
//       bar: {
//         horizontal: true,
//         barHeight: '70%',
//       },
//     },
//     tooltip: {
//       theme: "dark",
//       enabled: true,
//       style: {
//         fontSize: '14px',
//       },
//       onDatasetHover: {
//         highlightDataSeries: true,
//       },
//     },
//     dataLabels: { enabled: false },
//     stroke: {
//       show: true,
//       width: 2,
//       colors: ['transparent']
//     },
//     xaxis: {
//       labels: {
//         formatter: function (value) {
//           return 'R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
//         },
//         style: {
//           colors: "white",
//         }
//       },
//     },
//     yaxis: {
//       categories: [...mesesComValor].sort((a, b) => mapaMeses[a] - mapaMeses[b]),
//       labels: {
//         formatter: function (val) {
//           const mesAbreviado = {
//             'Janeiro': 'Jan',
//             'Fevereiro': 'Fev',
//             'Março': 'Mar',
//             'Abril': 'Abr',
//             'Maio': 'Mai',
//             'Junho': 'Jun',
//             'Julho': 'Jul',
//             'Agosto': 'Ago',
//             'Setembro': 'Set',
//             'Outubro': 'Out',
//             'Novembro': 'Nov',
//             'Dezembro': 'Dez'
//           };
//           return mesAbreviado[val] || val;
//         },
//         style: {
//           colors: "white",
//         }
//       }
//     },
//     fill: { opacity: 1 },
//     responsive: [
//       {
//         breakpoint: 768,
//         options: {
//           title: {
//             style: { fontSize: '14px' }
//           }
//         }
//       }
//     ]
//   };

//   return (
//     <Card bg="#0B0B61" color="white" borderRadius={0} align='center' direction='column' w='100%'>
//       <Flex align='center' w='100%' px='15px' py='10px'>
//         <Text me='auto' fontSize='xl' fontWeight='700' lineHeight='100%'>
//           Evolução de vendas mensal
//         </Text>
//       </Flex>
//       <Box h='500px' mt='auto'>
//         <ReactApexChart
//           options={options}
//           series={seriesArray}
//           type='bar'
//           width='100%'
//           height='100%'
//         />
//       </Box>
//     </Card>
//   )
// }
import axios from 'axios';
import {
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

export default function Mensal({ data, anos }) {
  const [barChart, setbarChart] = useState([]);
  const [ano, setAno] = useState('');

  useEffect(() => {
    setbarChart(data);
    setAno(anos);
  }, [data]);

  const mesesAno = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
  const series = {};
  let valorTotalGeral = 0;

  for (let i = 0; i < barChart.length; i++) {
    const dado = barChart[i];
    const name = dado.Status;

    if (!series[name]) {
      series[name] = {
        name: name,
        data: [],
      };
    }

    valorTotalGeral += dado.Total;

    series[name].data.push({
      x: dado.Mes,
      y: dado.Total
    });

    series[name].data.sort((a, b) => a.x - b.x);
  }

  for (const serie of Object.values(series)) {
    const dataMonths = serie.data.map(ponto => ponto.x);
    for (const month of mesesAno) {
      if (!dataMonths.includes(month)) {
        serie.data.push({ x: month, y: 0 });
      }
    }
  }

  // Ordena os meses corretamente
  const mesesNaOrdemDesejada = [...mesesAno];
  const mapaMeses = {};
  mesesNaOrdemDesejada.forEach((mes, index) => {
    mapaMeses[mes] = index;
  });

  const reorganizarSeriesArray = (seriesArray, mesesMap) => {
    return seriesArray.map(series => ({
      ...series,
      data: series.data.sort((a, b) => mesesMap[a.x] - mesesMap[b.x])
    }));
  };

  let seriesArray = Object.values(series);
  seriesArray = reorganizarSeriesArray(seriesArray, mapaMeses);

  const title = ano + " - Valor Total do Período - R$" + valorTotalGeral.toLocaleString('pt-BR', { minimumFractionDigits: 2 });

  const options = {
    chart: {
      type: 'bar',
      height: 500,
      stacked: true,
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    title: {
      text: title,
      align: 'center',
      margin: 10,
      style: {
        fontSize: '18px',
        fontWeight: 'bold',
        color: 'white'
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '70%',
      },
    },
    tooltip: {
      theme: "dark",
      enabled: true,
      style: {
        fontSize: '14px',
      },
      onDatasetHover: {
        highlightDataSeries: true,
      },
    },
    dataLabels: { enabled: false },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent']
    },
    xaxis: {
      labels: {
        formatter: function (value) {
          return 'R$ ' + value.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        style: {
          colors: "white",
        }
      },
    },
    yaxis: {
      categories: mesesAno,
      labels: {
        formatter: function (val) {
          const mesAbreviado = {
            'Janeiro': 'Jan',
            'Fevereiro': 'Fev',
            'Março': 'Mar',
            'Abril': 'Abr',
            'Maio': 'Mai',
            'Junho': 'Jun',
            'Julho': 'Jul',
            'Agosto': 'Ago',
            'Setembro': 'Set',
            'Outubro': 'Out',
            'Novembro': 'Nov',
            'Dezembro': 'Dez'
          };
          return mesAbreviado[val] || val;
        },
        style: {
          colors: "white",
        }
      }
    },
    fill: { opacity: 1 },
    responsive: [
      {
        breakpoint: 768,
        options: {
          title: {
            style: { fontSize: '14px' }
          }
        }
      }
    ]
  };

  return (
    <Card bg="#0B0B61" color="white" borderRadius={0} align='center' direction='column' w='100%'>
      <Flex align='center' w='100%' px='15px' py='10px'>
        <Text me='auto' fontSize='xl' fontWeight='700' lineHeight='100%'>
          Evolução de vendas mensal
        </Text>
      </Flex>
      <Box h='500px' mt='auto'>
        <ReactApexChart
          options={options}
          series={seriesArray}
          type='bar'
          width='100%'
          height='100%'
        />
      </Box>
    </Card>
  );
}
